const size = {
  xs: "320px",
  sm: "600px",
  md: "768px",
  lg: "1400px",
  xlg: "3000px",
}

const device = {
  xs: `(min-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  md: `(min-width: ${size.md})`,
  lg: `(min-width: ${size.lg})`,
  xlg: `(min-width: ${size.xlg})`,
  max_xs: `(max-width: ${size.xs})`,
  max_sm: `(max-width: ${size.sm})`,
  max_md: `(max-width: ${size.md})`,
  max_lg: `(max-width: ${size.lg})`,
  max_xlg: `(max-width: ${size.xlg})`,
}

export default { device }
